import React from 'react'
import { observer } from 'mobx-react'
import MapContainer from 'components/map/MapContainer'
import AnalysisContainer from 'components/analysis/AnalysisContainer'
import { inject } from 'mobx-react'

// When printing, the print CSS rules will take effect, meaning
// only the DOM of PrintContainer will be printed. These CSS rules can
// be debugged in Chrome with:
// Dev tools menu > More tools > Rendering settings > Emulate CSS media
const PrintContainer = ({ uiStore }) => (
  <div className='print-page'>
    {uiStore.print && [
      <MapContainer printMap key='map-print' />,
      <AnalysisContainer key='analysis-print' />
    ]}
  </div>
)

export default inject('uiStore')(observer(PrintContainer))
